export const LANGGRAPH_INTEGRATION_NAME = 'LangGraph';
export const LANGGRAPH_ORIGIN = 'auto.ai.langgraph';



// WEBPACK FOOTER //
// ../../../../src/tracing/langgraph/constants.ts